import React from 'react';
import Link from '@/components/atoms/link';
import useCustomRouter from '@/hooks/useCustomRouter';
import { classnames } from '@/utils/classnames/classnames';
import { useTranslations } from 'use-intl';
import { Props } from './types';

const PreviousPageLink = ({ className }: Props) => {
  const router = useCustomRouter();

  const translate = useTranslations();

  return (
    <Link
      className={classnames('text-14 leading-normal text-blue-700', className)}
      href="#"
      onClick={() => router.back()}
    >
      {translate('common.back-to-previous-page')}
    </Link>
  );
};

export default PreviousPageLink;
